import { Menu, type MenuClickTriggerProps, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import { memo, type ReactElement } from "react"

import {
	OrganizationAccessLevelSelectGroup,
	type OrganizationAccessLevelSelectGroupProps,
} from "../MenuSelectGroups/OrganizationAccessLevelSelectGroup"

type OrganizationAccessLevelSelectProps = Omit<MenuRootProps, "children"> &
	Omit<MenuClickTriggerProps, "children"> &
	MenuVariantProps &
	OrganizationAccessLevelSelectGroupProps & {
		children: ReactElement
	}

export const OrganizationAccessLevelSelect = memo<OrganizationAccessLevelSelectProps>((props) => {
	const {
		// Trigger props
		children,
		disabled = false,
		// MenuContent props
		size,
		radius,
		variant,
		accentColor,
		// OrganizationAccessLevelSelectGroup props
		required,
		defaultValue,
		value,
		onValueChange,
		// Rest props
		...rest
	} = props

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content size={size} radius={radius} variant={variant} accentColor={accentColor}>
				<Menu.Scroll>
					{required ? (
						<OrganizationAccessLevelSelectGroup
							required={required}
							value={value}
							defaultValue={defaultValue}
							onValueChange={onValueChange}
						/>
					) : (
						<OrganizationAccessLevelSelectGroup
							required={required}
							value={value}
							defaultValue={defaultValue}
							onValueChange={onValueChange}
						/>
					)}
				</Menu.Scroll>
			</Menu.Content>
		</Menu.Root>
	)
})
OrganizationAccessLevelSelect.displayName = "OrganizationAccessLevelSelect"
